import { UserManager, User } from 'oidc-client-ts';

import { oidcConfig } from '../oidc';

export interface ImpersonationTokenData {
  access_token: string;
  expires_in: string; // URLSearchParams gives strings
  token_type: string;
  id_token: string;
  scope: string;
}

class AuthService {
  public userManager: UserManager;

  constructor() {
    this.userManager = new UserManager(oidcConfig);
  }

  public getUser() {
    return this.userManager.getUser();
  }

  public login() {
    // signinRedirect starts the login process
    return this.userManager.signinRedirect();
  }

  public signinRedirectCallback() {
    // This is called on the /callback page
    return this.userManager.signinRedirectCallback();
  }

  public logout() {
    // signoutRedirect starts the logout process
    return this.userManager.signoutRedirect();
  }

  public signoutRedirectCallback() {
    // This is called on the post-logout redirect page
    return this.userManager.signoutRedirectCallback();
  }

  public async getAccessToken() {
    const user = await this.userManager.getUser();
    return user?.access_token;
  }

  public async getLanguage() {
    const user = await this.userManager.getUser();
    return user?.profile?.locale;
  }

  // This method is useful for manual renewal if needed
  public signinSilent() {
    return this.userManager.signinSilent();
  }

  public async impersonate(token: string) {
    // Manually create a User object. This is the key step.
    // @ts-expect-error - only access_token is needed for impersonation
    const user = new User({
      access_token: token,
    });

    // Store the user manually. This overwrites any existing session.
    await this.userManager.storeUser(user);

    // Return the user object for convenience
    return user;
  }
}

// Export a singleton instance of the service
const authService = new AuthService();
export default authService;
